const messages: Record<string, string> = {
	'button.start': 'Següent »',
};

export default messages;
